// removed by extract-text-webpack-plugin
module.exports = {"globalHeader":"src-components-Header----header-module---globalHeader---vVhrF src-styles----index---container---1O8Oe","logo":"src-components-Header----header-module---logo---LcN1p","menuToggle":"src-components-Header----header-module---menuToggle---2yHen","icon":"src-components-Header----header-module---icon---3SmgZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/header.module.scss
// module id = 344
// module chunks = 168707334958949